import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Calendar, Clock } from "lucide-react";

export default function Longevity2025() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1">
        <div className="container max-w-4xl mx-auto px-4 py-12">
          <div className="space-y-6">
            <div className="flex items-center text-[#7F8C8D] text-sm mb-4">
              <div className="flex items-center mr-4">
                <Calendar className="h-4 w-4 mr-2" />
                <span>April 8, 2025</span>
              </div>
              <div className="flex items-center">
                <Clock className="h-4 w-4 mr-2" />
                <span>5 min read</span>
              </div>
            </div>
            
            <h1 className="text-4xl font-serif font-bold text-[#2C3E50]">
              Why 2025 is the best year to start in longevity medicine
            </h1>
            
            <p className="text-xl text-[#7F8C8D] leading-relaxed mb-8">
              Current trends and opportunities in longevity medicine
            </p>
            
            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg p-8 my-12 text-center">
              <h2 className="text-2xl font-medium text-[#2C3E50] mb-4">Coming Soon</h2>
              <p className="text-[#7F8C8D] mb-6">
                We're preparing an in-depth analysis on why 2025 presents unique opportunities in the field of longevity medicine. 
                This article will explore current research breakthroughs, investment trends, and technological advancements that 
                make this year particularly significant.
              </p>
              <p className="text-[#7F8C8D]">
                Please check back soon for the full article.
              </p>
            </div>
            
            <div className="border-t border-[#E2E8F0] pt-8 mt-12">
              <h3 className="text-xl font-medium text-[#2C3E50] mb-4">Topics we'll cover:</h3>
              <ul className="list-disc pl-6 space-y-2 text-[#7F8C8D]">
                <li>Recent breakthroughs in aging research</li>
                <li>Emerging biotech companies focused on longevity</li>
                <li>Policy changes affecting longevity medicine</li>
                <li>Investment trends in age-related research</li>
                <li>Accessible technologies for personal health monitoring</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}